import React, { Component } from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom'
import logoHome from './images/logo.png'
import quoc_ky from './images/quoc_ky.png'
import quoc_ky_anh from './images/quoc_ky_anh.png'

class Header extends Component {
  state = {
    active_1: "#0E9347",
    active_2: "",
    active_3: "",
    active_4: "",
    bored_1: "#0E9347",
    bored_2: "#FFFFFF",
    bored_3: "#FFFFFF",
    bored_4: "#FFFFFF",
    check: true,
    open_opacity: '',
    open_sidebar_menu: ''
  };
  replace = (value) => {
    // if (value == "active_1") {
    //   this.setState({
    //     active_1: "#0E9347",
    //     active_2: "",
    //     active_3: "",
    //     active_4: "",
    //     bored_1: "",
    //     bored_2: "#FFFFFF",
    //     bored_3: "#FFFFFF",
    //     bored_4: "#FFFFFF",
    //   })
    // } else if (value == "active_2") {
    //   this.setState({
    //     active_1: "",
    //     active_2: "#0E9347",
    //     active_3: "",
    //     active_4: "",
    //     bored_1: "#FFFFFF",
    //     bored_2: "",
    //     bored_3: "#FFFFFF",
    //     bored_4: "#FFFFFF",
    //   })
    // } else if (value == "active_3") {
    //   this.setState({
    //     active_1: "",
    //     active_2: "",
    //     active_3: "#0E9347",
    //     active_4: "",
    //     bored_1: "#FFFFFF",
    //     bored_2: "#FFFFFF",
    //     bored_3: "",
    //     bored_4: "#FFFFFF",
    //   })
    // } else if (value == "active_4") {
    //   this.setState({
    //     active_1: "",
    //     active_2: "",
    //     active_3: "",
    //     active_4: "#0E9347",
    //     bored_1: "#FFFFFF",
    //     bored_2: "#FFFFFF",
    //     bored_3: "#FFFFFF",
    //     bored_4: "",
    //   })
    // }
  }
  render() {
    const { active_1, active_2, active_3, active_4, bored_1, bored_2, bored_3, bored_4, open_opacity, open_sidebar_menu } = this.state
    return (
      <>
        <div class={`opacity_menu ${open_opacity}`} onClick={() => this.setState({ open_opacity: '', open_sidebar_menu: '' })}></div>
        <div className="wraphead_mobile clearfix">
          <div className="container" style={{ maxWidth: 'initial' }}>
            <div className="row">
              <div className="col-lg-2 col-md-12" style={{ marginLeft: '2%' }}>
                <div className="logo">
                  <Link title="Beex" to="/" className="logo-wrapper">
                    <img style={{ width: '93px', height: '36px' }} src={logoHome} alt="Beex" />
                  </Link>
                </div>
              </div>
              <div className="col-lg-8 col-xl-9 col-md-0" style={{ marginLeft: '-2%' }}>
                <div className="head_nav">
                  <div className="wrap_main d-none d-lg-block d-xl-block">
                    <div className="header-nav">
                      <ul className="item_big">
                        <li className="nav-item">
                          <Link style={{ color: `${active_1}`, borderBottom: `2px solid ${bored_1}` }} onClick={() => this.replace("active_1")} title="Trang chủ" to="/" className="a-img">
                            <span>Trang chủ</span>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <a href="#section_1" style={{ color: `${active_2}`, borderBottom: `2px solid ${bored_2}` }} onClick={() => this.replace("active_1")} title="Giới thiệu" to="/Introduce" className="a-img">
                            <span>Giới thiệu</span>
                          </a>
                        </li>
                        <li className="nav-item ">
                          <a href="#section_2" style={{ color: `${active_3}`, borderBottom: `2px solid ${bored_3}` }} onClick={() => this.replace("active_1")} title="Ưu điểm" className="a-img">
                            <span>Ưu điểm</span>
                          </a>
                        </li>
                        <li className="nav-item ">
                          <a href="#section_3" style={{ color: `${active_4}`, borderBottom: `2px solid ${bored_4}` }} onClick={() => this.replace("active_1")} title="Mô hình hệ thống" to="/Contact" className="a-img">
                            <span>Mô hình hệ thống</span>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a href="#section_4" style={{ color: `${active_2}`, borderBottom: `2px solid ${bored_2}` }} onClick={() => this.replace("active_1")} title="Dịch vụ" to="/Introduce" className="a-img">
                            <span>Dịch vụ</span>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a href="#section_5" style={{ color: `${active_2}`, borderBottom: `2px solid ${bored_2}` }} onClick={() => this.replace("active_1")} title="Liên hệ" to="/Introduce" className="a-img">
                            <span>Liên hệ</span>
                          </a>
                        </li>
                        <li className="nav-item ">
                          <a className="a-img" href="https://portal.beex.vn" target="_blank" title="Đăng nhập">
                            <Button size='large' style={{ background: "#0E9347", borderRadius: "5px", border: "1px" }}>
                              <span className="b-center">Đăng nhập</span>
                            </Button>
                          </a>
                        </li>
                        <li className="nav-item ">
                          <a className="a-img" href="https://portal.beex.vn" title="Đăng ký">
                            <span>Đăng ký</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-1 col-xl-1 col-md-12">
                <div className="cartsearch">
                  <div className="carthd">
                    <div className="mini-cart text-xs-center">
                      <div className="heading-cart cart_header">
                        <div className="icon_hotline">
                          {this.state.check ?
                            <Link to='/' onClick={() => this.setState({ check: !this.state.check })}>
                              <img className='quoc_ky' src={quoc_ky} />
                            </Link>
                            :
                            <Link to='/' onClick={() => this.setState({ check: !this.state.check })}>
                              <img className='quoc_ky' src={quoc_ky_anh} />
                            </Link>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <span className="menubutton d-block d-lg-none d-xl-none" onClick={() => this.setState({ open_opacity: 'open_opacity', open_sidebar_menu: 'open_sidebar_menu' })}><i className="fas fa-bars" /></span>
          <div className={`wrapmenu_right clearfix ${open_sidebar_menu}`}>
            <div className="wrapmenu">
              <div className="wrapmenu_full menumain_full">
                <div className="containers">
                  {/* Menu mobile */}
                  <div className="contenttop p-r-30">
                    <div className="section margin-bottom-10 margin-top-15 a-left">
                      <span className="menubutton d-block d-lg-none d-xl-none" style={{ top: '18px' }} onClick={() => this.setState({ open_opacity: '', open_sidebar_menu: '' })}><i className="fas fa-bars" /></span>
                    </div>
                    <div className="logisn clearfix margint-top-15 margin-bottom-15" style={{ marginLeft: '52px', marginTop: '-2px' }}>
                      <a className="btnx" href="https://portal.beex.vn">Đăng nhập</a>&nbsp;/
                      <a href="https://portal.beex.vn">Đăng ký</a>
                    </div>
                  </div>
                  <div className="menu_mobile clearfix">
                    <ul className="ul_collections">
                      <li className="level0 level-top parent">
                        <Link style={{ color: `${active_1}`, borderBottom: `2px solid ${bored_1}` }} onClick={() => (this.replace("active_1"), this.setState({ open_opacity: '', open_sidebar_menu: '' }))} title="Trang chủ" to="/" className="a-img">
                          <span>Trang chủ</span>
                        </Link>
                      </li>
                      <li className="level0 level-top parent">
                        <a href="#section_1" style={{ color: `${active_2}`, borderBottom: `2px solid ${bored_2}` }} onClick={() => (this.replace("active_2"), this.setState({ open_opacity: '', open_sidebar_menu: '' }))} title="Giới thiệu" to="/Introduce" className="a-img">
                          <span>Giới thiệu</span>
                        </a>                      </li>
                      <li className="level0 level-top parent">
                        <a href="#section_2" style={{ color: `${active_3}`, borderBottom: `2px solid ${bored_3}` }} onClick={() => (this.replace("active_3"), this.setState({ open_opacity: '', open_sidebar_menu: '' }))} title="Giải pháp" className="a-img">
                          <span>Ưu điểm</span>
                        </a>
                      </li>
                      <li className="level0 level-top parent">
                        <a href="#section_3" style={{ color: `${active_4}`, borderBottom: `2px solid ${bored_4}` }} onClick={() => (this.replace("active_4"), this.setState({ open_opacity: '', open_sidebar_menu: '' }))} title="Liên hệ" to="/Contact" className="a-img">
                          <span>Mô hình hệ thống</span>
                        </a>
                      </li>
                      <li className="level0 level-top parent">
                        <a href="#section_4" style={{ color: `${active_4}`, borderBottom: `2px solid ${bored_4}` }} onClick={() => (this.replace("active_4"), this.setState({ open_opacity: '', open_sidebar_menu: '' }))} title="Liên hệ" to="/Contact" className="a-img">
                          <span>Dịch vụ</span>
                        </a>
                      </li>
                      <li className="level0 level-top parent">
                        <a href="#section_5" style={{ color: `${active_4}`, borderBottom: `2px solid ${bored_4}` }} onClick={() => (this.replace("active_4"), this.setState({ open_opacity: '', open_sidebar_menu: '' }))} title="Liên hệ" to="/Contact" className="a-img">
                          <span>Liên hệ</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="p-r-30 clearfix margin-top-15">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
export default Header